var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-form-input',{staticClass:"reply-placeholder-input-field js-discussion-reply-field-placeholder",attrs:{"data-testid":"discussion-reply-tab","placeholder":_vm.placeholderText,"aria-label":_vm.labelText},on:{"focus":function($event){return _vm.$emit('focus')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }